import type React from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from '@workspace/ui/components/Button';

import Icon from '~/components/Icon/Icon';
import { ModalType } from '~/components/Modal/interface';
import { useModal } from '~/hooks/useModal';
import { userStore } from '~/stores';

const iconButtonClasses =
  'size-12! max-h-none! p-0! border-transparent bg-navigation-surface text-navigation-icon-primary hover:bg-navigation-surface-2';

export const ProfileButton: React.FC = () => {
  const { openModal } = useModal();
  const navigate = useNavigate();

  const profilePath = '/cabinet';

  const handleClick = () => {
    if (!userStore.isAuthorized) {
      openModal(ModalType.Auth, 'header', { redirect: profilePath });
      return;
    }
    navigate(profilePath);
  };

  return (
    <Button
      variant="secondary"
      startIcon={<Icon type="profile-3.1" width={20} height={19} />}
      className={iconButtonClasses}
      onClick={handleClick}
      data-button="header-cabinet"
    />
  );
};
